import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import DegreesIcon from './icons/DegreesIcon';

interface DegreesToggleProps {
  showDegrees: boolean;
  onToggleDegrees: () => void;
}

/** Header switch for chord degrees (I, IV, V), next to the Tones and Lyrics switches. */
const DegreesToggle: React.FC<DegreesToggleProps> = ({ showDegrees, onToggleDegrees }) => {
  const { theme } = useTheme();
  const label = showDegrees ? 'Hide degrees' : 'Show degrees';

  return (
    <button
      onClick={onToggleDegrees}
      style={{
        width: '32px',
        height: `${theme.spacing.xl - 4}px`, // 20px, like NoteToggle / LyricsToggle
        borderRadius: `${theme.radii.full}px`,
        padding: '2px',
        position: 'relative',
        backgroundColor: showDegrees ? theme.colors.key : theme.colors.textSecondary,
        border: 'none',
        cursor: 'pointer',
        transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
      }}
      aria-label={label}
      aria-pressed={showDegrees}
      title={label}
      data-testid="degrees-toggle"
    >
      <div
        style={{
          width: `${theme.spacing.lg}px`,
          height: `${theme.spacing.lg}px`,
          borderRadius: `${theme.radii.lg}px`,
          backgroundColor: theme.colors.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: showDegrees ? 'calc(100% - 18px)' : '2px',
          top: '2px',
          transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
        }}
      >
        <DegreesIcon size={12} color={showDegrees ? theme.colors.key : theme.colors.textTertiary} />
      </div>
    </button>
  );
};

export default DegreesToggle;
